export default __webpack_public_path__ + "static/media/x market white 1.e8412016.svg";